import React, { useState } from "react";
import GrayCard from "components/gray-card";

import styled from "styled-components";

import { Colors } from "utils/colors";
import Dropdown from "components/inputs/dropdown";
import TextInput from "components/inputs/text-input";

interface IProps {
  data: string;
  setData: (data: string) => void;
}
const ISRC = ({ data, setData }: IProps) => {
  const [selectedItem, setSelectedItem] = useState("Auto");
  return (
    <GrayCard title="ISRC">
      <Grid>
        <Dropdown
          chosenItem={selectedItem}
          items={["Auto", "Manual"]}
          selectItem={(value) => setSelectedItem(value)}
        />
        <TextInput
          placeholder="Auto Generated"
          value={data}
          onChange={(e) => setData(e.target.value)}
          disabled={selectedItem === "Auto"}
          lockTip="default"
        />
      </Grid>
    </GrayCard>
  );
};

export default ISRC;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 14% 83%;
  align-items: center;
  justify-content: space-between;
`;
